import React from 'react';
import * as Styled from './styled';
import { SmallText } from 'ds/components/typography';
import { useLocale } from 'locale';
import DisclaimerModal from './DisclaimerModal';
import { PostFeedbackModal } from './PostFeedBackModal';
import { InvestorsFeedbackModalState } from 'store/state/app';

interface DisclaimerBarProps {
  modalState: InvestorsFeedbackModalState;
  onModalState: (state: InvestorsFeedbackModalState) => void;
}

export const DisclaimerBar: React.FC<DisclaimerBarProps> = props => {
  const { modalState, onModalState } = props;
  const { isPostFeedbackModalOpen, isModalOpen } = modalState;
  const { t } = useLocale();

  return (
    <>
      <Styled.Root data-auto="investors_disclaimer_bar" onClick={() => onModalState({ ...modalState, isModalOpen: true })}>
        <SmallText>{t('investors.disclaimer.title.copy')}</SmallText>
        <Styled.Btn >
          {t('investors.disclaimer.submit.copy')}
        </Styled.Btn>
      </Styled.Root>
      {isModalOpen && <DisclaimerModal onModalClose={onModalState} />}
      {isPostFeedbackModalOpen && <PostFeedbackModal onModalClose={onModalState} />}
    </>
  );
};
